var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoryFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#233544",
    d: "M17.993 2H6.007C4.353 2 3 3.3 3 4.908v14.184C3 20.692 4.353 22 6.007 22h11.986C19.647 22 21 20.692 21 19.092V4.908C21 3.3 19.647 2 17.993 2Zm-6.04 16.95H7.846c-.514 0-.93-.404-.93-.9 0-.498.416-.9.93-.9h4.109c.514 0 .93.402.93.9 0 .496-.416.9-.93.9Zm4.2-4.3H7.846c-.514 0-.93-.403-.93-.9s.416-.9.93-.9h8.309c.514 0 .93.403.93.9s-.416.9-.93.9Zm1.235-8.104-2.985 3.218a.956.956 0 0 1-1.192.158l-2.896-1.786-2.341 2.362a.952.952 0 0 1-1.315.027.878.878 0 0 1-.028-1.272l2.868-2.896a.956.956 0 0 1 1.173-.136l2.874 1.773 2.458-2.65a.954.954 0 0 1 1.314-.068c.382.331.414.9.07 1.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryFill);
export default __webpack_public_path__ + "static/media/history-fill.0215ff8ce634ca301746d3bf713f61c3.svg";
export { ForwardRef as ReactComponent };